const FRONTEND = {
  MODAL_POSITION_LEFT: 'LEFT',
  GOOGLE_ANALYTICS: 'G-F4Z6SG4HDE',
  FORM_NAME: 'PreRegistration',
};

export const languagesData = [
  {
    id: 1,
    language: 'da',
    label: 'Danish',
    selected: false,
  },
  {
    id: 2,
    language: 'en',
    label: 'English',
    selected: true,
  },
  {
    id: 3,
    language: 'it',
    label: 'Italian',
    selected: false,
  },
  {
    id: 4,
    language: 'es',
    label: 'Spanish',
    selected: false,
  },
];

export interface LanguageInterface {
  id: number,
  language: string,
  label: string,
  selected: boolean,
}

export default FRONTEND;
